module.exports = __webpack_public_path__ + "img/sec1_05.11447675.png";